import { EventEmitter } from "events";
import StoreContainer from "../stores/StoreContainer";
import { SocialData } from "../types";
import CookieStore from "./CookieStore";

class OAuthStore {
  private _emitter = new EventEmitter();
  private _socialData: SocialData;
  private _cookieStore: CookieStore;

  constructor(cookieStore: CookieStore) {
    this._cookieStore = cookieStore;
    this._socialData = this._cookieStore.get("socialData");
  }

  onReceiveSocialData(callback: (socialData: SocialData) => void) {
    this._emitter.addListener("receiveSocialData", callback);
  }

  getSocialData() {
    return this._socialData;
  }

  connectFacebook() {
    this.connectSource("facebook", "facebook");
  }

  connectTwitter() {
    this.connectSource("twitter", "twitter");
  }

  connectGoogle() {
    this.connectSource("google", "google");
  }

  connectLinkedIn() {
    this.connectSource("linkedin", "linkedin");
  }

  connectSource(endpoint: string, source: string) {
    const url = `${StoreContainer.SettingStore.getEngagementApiEndpoint()}/v1/social/${endpoint}/${StoreContainer.SettingStore.getSiteId()}/${StoreContainer.VisitorStore.getVisitorId()}/${StoreContainer.EngagementStore.getPreEngagementId()}`;
    window.open(url, "_new", "width=500, height=500");

    const handleMessage = (event: any) => {
      try {
        const message = JSON.parse(event.data);

        if (message.type !== "velaro:social:callback") {
          return;
        }

        this.loadSocialData(source, message.payload);
        window.removeEventListener("message", handleMessage);
      } catch (err) {
        console.error(err);
      }
    };

    window.addEventListener("message", handleMessage, false);
  }

  removeAllListeners() {
    this._emitter.removeAllListeners();
  }

  private async loadSocialData(source: string, payload: any) {
    this._socialData = {
      source,
      displayName: payload.displayName,
      email: payload.email,
      headshotUrl: payload.headshotUrl
    };

    StoreContainer.CookieStore.set("socialData", this._socialData);
    this._emitter.emit("receiveSocialData", this._socialData);
  }
}

export default OAuthStore;
